import React, { FC } from 'react';

import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import IosShareIcon from '@mui/icons-material/IosShare';
import MoreHorizIconIcon from '@mui/icons-material/MoreHoriz';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

interface ProfileHeaderProps {
  isToShowUnsubscribedUI: boolean;
  isToShowSubscribedUI: boolean;
  isPublic?: boolean;
  onClose: () => any;
  onMenuClick: (event: any) => any;
  onShare: () => any;
}

const ProfileHeader: FC<ProfileHeaderProps> = ({
  isToShowSubscribedUI,
  isToShowUnsubscribedUI,
  isPublic = false,
  onClose,
  onMenuClick,
  onShare,
}) => (
  <AppBar
    variant="elevation"
    color="transparent"
    sx={{
      boxShadow: 'none',
      position: { xs: 'absolute', md: 'sticky' },
      background: { xs: 'transparent' },
    }}
  >
    <br />
    <Toolbar sx={{ justifyContent: 'space-between', paddingTop: '34px' }}>
      {!isPublic && (
        <IconButton color="info" size="large" onClick={onClose}>
          <ArrowBackIos sx={{ fontSize: '22px' }} />
        </IconButton>
      )}
      {isToShowUnsubscribedUI && (
        <IconButton
          color="info"
          size="large"
          onClick={onShare}
          sx={{ border: 'none', padding: '6px', marginLeft:'auto' }}
        >
          <IosShareIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      )}
      {isToShowSubscribedUI && (
        <IconButton
          color="info"
          size="large"
          onClick={onMenuClick}
          sx={{ border: '1px solid #FFF', padding: '6px' }}
        >
          <MoreHorizIconIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      )}
    </Toolbar>
  </AppBar>
);

export default ProfileHeader;
